import { Component, Input } from "@angular/core";
import { Eye } from "../../../global-data-models/visit.model";
import { COMMON_IMPORTS } from "../../../global-misc/common-imports";
import { FormGroup } from "@angular/forms";
import { SelectButtonModule } from "primeng/selectbutton";
import { InputNumberModule } from "primeng/inputnumber";
import { MEASUREMENT_RANGES } from "../crud-visit.facade";

@Component({
    selector: "app-crud-eye-measurement",
    standalone: true,
    imports: [...COMMON_IMPORTS, SelectButtonModule, InputNumberModule],
    templateUrl: "./crud-measurement.component.html",
    styleUrls: ["./crud-measurement.component.css"]
})
export class CrudMeasurementComponent {
    public readonly Eye = Eye;
    public readonly MEASUREMENT_RANGES = MEASUREMENT_RANGES;

    @Input() eyeSide!: Eye;
    @Input() form!: FormGroup;

    public constructor() { }
}
